<div class="form-check py-2 d-flex align-items-end" *ngIf="control" [ngStyle]="style">
    <input class="form-check-input" type="checkbox" id="{{id}}" [formControl]="control">
    <label class="form-check-label ms-2" for="{{id}}" [style.color]="labelColor">
      {{label}}
    </label>
  </div>